import { render, staticRenderFns } from "./channelEditMultiLanguage.vue?vue&type=template&id=0c491fc6&"
import script from "./channelEditMultiLanguage.vue?vue&type=script&lang=ts&"
export * from "./channelEditMultiLanguage.vue?vue&type=script&lang=ts&"
import style0 from "./channelEditMultiLanguage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports